import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

export default class extends Controller {
  static values = {
    auditId: Number,
    url: String
  }

  showModal() {
    const modalElement = document.getElementById('auditRestoreModal')
    const auditIdInput = document.getElementById('auditRestoreAuditId')
    
    if (modalElement && auditIdInput) {
      auditIdInput.value = this.auditIdValue
      
      // Show the modal using Bootstrap
      const modal = new Modal(modalElement)
      modal.show()
    }
  }
}
